import {
  FileTextIcon,
  ZapIcon,
  GraduationCapIcon,
  SmartphoneIcon,
  ShieldCheckIcon,
  LockIcon,
  CreditCardIcon,
} from 'lucide-react';

export const heroChips = [
  { icon: FileTextIcon, label: '100% PDF' },
  { icon: ZapIcon, label: 'Immediate access' },
  { icon: GraduationCapIcon, label: 'University students' },
  { icon: SmartphoneIcon, label: 'Android & iOS' },
];

export const heroTrust = [
  { icon: ShieldCheckIcon, label: '7-Day Guarantee' },
  { icon: LockIcon, label: 'Secure Payment' },
  { icon: CreditCardIcon, label: 'Credit / Debit' },
  { icon: ZapIcon, label: 'Immediate Access' },
];

export const stats = [
  { value: '+500', label: 'Students trust us ⭐' },
  { value: '12', label: 'Volumes ready' },
  { value: '5', label: 'Bonuses included' },
  { value: '4.9/5', label: 'Rating' },
];
